module.exports = __webpack_public_path__ + "static/media/gotquizTextImage.d316d3e8.png";